export default {
    data () {
        return {
            numberOfLoadedImages: 0,
            imagesToLoad: null
        }
    },
    computed: {
        isAllImagesLoaded: function (){
            return this.numberOfLoadedImages === this.imagesToLoad.length
        }
    },
    methods: {
        awaitImagesLoading(selector = 'body') {
            return new Promise((resolve) => {
                this.imagesToLoad = document.querySelectorAll(`${selector} img`);

                if (this.imagesToLoad.length) {
                    this.imagesToLoad.forEach((image) => {
                        image.addEventListener('load', (event) => {
                            this.numberOfLoadedImages += 1;
                            if (this.isAllImagesLoaded)
                                resolve();
                        });
                        image.addEventListener('error', (event) => {
                            this.numberOfLoadedImages += 1;
                            if (this.isAllImagesLoaded)
                                resolve();
                        });
                    })
                } else {
                    resolve()
                }
            })
        }
    }
}
